import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildProductStructuredData } from 'utils/StructuredData';
import { priceFormatter } from 'utils/Numbers';
import FontIcon from 'components/FontIcon';
import AffirmContainer from 'containers/AffirmContainer/AffirmContainer';
import classes from './CardProductDItem.module.scss';

const CardProductDItem = (props) => {
  const {
    product, productIndex, isSelected, onClick, showDetails, hash,
  } = props;
  const {
    price,
    originalPrice,
    displayName,
    subtitle,
    description,
    isAffirmEligible,
  } = product;

  return (
    <div className={classes.optContainer}>
      <input
        id={`${productIndex}-label-${hash}`}
        type='radio'
        name={`cardProductD-${hash}`}
        className={classes.optionInput}
        onClick={(e) => onClick(e, productIndex)}
        aria-label={displayName}
      />
      <label
        htmlFor={`${productIndex}-label-${hash}`}
        className={classNames(classes.optLabel, { [classes.selected]: isSelected })}
        key={productIndex}
      >
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: buildProductStructuredData(product) }}
        />
        {price >= 0 &&
          <div className={classes.prices}>
            <div className={classes.price}>{priceFormatter(price)}</div>
            {originalPrice > price &&
              <div className={classes.originalPrice}>{priceFormatter(originalPrice)}</div>}
          </div>}
        <div className={classes.contentWrapper}>
          <div className={classes.indicator}>
            <span className='fa-stack'>
              <FontIcon title={`Remove ${displayName}`} icon='far fa-circle fa-stack-2x' />
              {isSelected && <FontIcon title={`Select ${displayName}`} icon='far fa-check fa-stack-1x' />}
            </span>
          </div>
          <div className={classes.content}>
            <div className={classes.titleAndInfoWrapper}>
              {displayName &&
                <div
                  className={classes.optTitle}
                  dangerouslySetInnerHTML={{ __html: displayName }}
                />}
            </div>
            {subtitle &&
              <div
                className={classes.subtitle}
                dangerouslySetInnerHTML={{ __html: subtitle }}
              />}
            {price >= 0 &&
              <div className={classes.affirmMessage}>
                <AffirmContainer price={price} isAffirmEligible={isAffirmEligible} className={classes.affirmMessage} />
              </div>}
            {description &&
              <>
                <button
                  className={classes.link}
                  aria-label='View Details'
                  onClick={(e) => showDetails(e, productIndex)}
                  type='button'
                >
                  View Details
                </button>
                {typeof window === 'undefined' &&
                  <div dangerouslySetInnerHTML={{ __html: description }} />}
              </>}
          </div>
        </div>
      </label>
    </div>
  );
};

const ButtonT = PropTypes.shape({
  subType: PropTypes.string.isRequired,
  title: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  onClick: PropTypes.func,
});

const ProductT = PropTypes.shape({
  imageURI: PropTypes.string,
  imageAltText: PropTypes.string,
  displayName: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  brand: PropTypes.string,
  organization: PropTypes.string,
  currency: PropTypes.string,
  price: PropTypes.number,
  originalPrice: PropTypes.number,
  button: ButtonT,
});

CardProductDItem.propTypes = {
  /**
   * Product info
  */
  product: ProductT,
  /**
   * Index of this particular product in the array of products
  */
  productIndex: PropTypes.number,
  /**
   * Boolean to mark this product as selected<br>
   * Options: true or false
  */
  isSelected: PropTypes.bool,
  /**
   * Callback when clicking the product
  */
  onClick: PropTypes.func,
  /**
   * Callback when expanding the details of the product
  */
  showDetails: PropTypes.func,
  /**
   * Hash code of the array of products
  */
  hash: PropTypes.string,
};

export default CardProductDItem;
